import createHistory from 'history/createBrowserHistory';

const history = createHistory();

export const gotoPage = (page) => {
    history.push(`/${page}`);
    window.scrollTo(0, 0);
};

export default history;


// WEBPACK FOOTER //
// ./src/app/history.js